export const ARTICLE_SLOT_PROPS = [
  'article-id',
  'title',
  'slug',
  'is-migrated',
  'is-session-wrap',
  'sponsorship-company',
  'category',
  'tldr',
  'is-pinned',
  'featured-image',
  'thumbnail-image',
  'featured-video',
  'author',
  'expanded-content',
  'terms',
  'published-on',
  'modified-on',
  'title-html-tag',
  'show-featured-media',
  'breakpoints-to-show-featured-media-on',
  'show-expandable-content',
  'breakpoints-to-show-expandable-content-on',
  'image-viewport-optimization',
  'image-srcset-location',
  'hide-category'
]
